<template>
  <div>
    <b-modal id="modal-member" :title="$t('profileBatch.addMember')" hide-footer size='xl'>
      <member-select-modal v-if="availableMembers && selectedMembers" :membersList="availableMembers"
        :preSelected="selectedMembers.map(x => x.member)" v-on:selected-members.capture="assignMembers" />
    </b-modal>
    <training-toolbar v-if="userInfo" />
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo" :title="$t('profileBatch.title')" :iconName="'person-check'" />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert" variant="danger" dismissible>
          {{ error.message }}
        </b-alert>
        <b-overlay :show="loadingBatch" spinner-variant="primary" rounded="sm">
          <template>
            <b-row class="mb-3">
              <b-input-group id="fieldset-horizontal" class="col-md-6 ">
                <b-input id="search-input" v-model="search" type="search"
                  :placeholder="$t('profileBatch.searchByName')"></b-input>
              </b-input-group>

              <b-button v-if="!loading" class="ml-auto mr-3 esep-blue-bg" variant="primary"
                :disabled="!this.search || this.search.length < 3" @click="getAvailableLeaders">
                {{ $t('profileBatch.search') }}
              </b-button>
              <b-button v-else class="ml-auto mr-3 esep-blue-bg" variant="primary" disabled>
                <b-spinner small></b-spinner>
                {{ $t('profileBatch.search') }}
              </b-button>
            </b-row>
            <template>
              <b-table ref="membersTable" id="members-table" striped hover borderless :items="selectedMembers"
                :fields="selectedMembersFields" responsive show-empty class="mt-2" :reduce="m => m.member"
                thead-class="esep-blue-bg text-light">

                <template v-slot:cell(action)="row">
                  <b-button size="sm" @click="deleteMember(row.item)" variant="transparent" v-b-tooltip.hover
                    :title="$t('profileBatch.deleteMember')">
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                </template>

                <template v-slot:cell(organiser)="row">
                  <b-checkbox v-model="row.item.organiser" />
                </template>

                <template v-slot:empty="">
                  <h6>{{ $t("profileBatch.emptyMembersTable") }}</h6>
                </template>

              </b-table>
                <b-form-group v-if="modules != null" id="input-group-module" :label="$t('profileBatch.module')"
                              label-align="left" class="col-lg-12 col-md-12 pl-0">
                  <v-select :options="modules" :placeholder="$t('parametrics.module')" label="title"
                            v-model="selectedModule" class="bg-white rounded">
                    <template #no-options="{}">
                      {{ $t("training-add.noOptions") }}
                    </template>
                  </v-select>
                </b-form-group>
            </template>
            <b-button @click="updateProfiles" variant="success" class="float-left"
              :disabled="!selectedModule || !selectedMembers">{{
                $t("profileBatch.update")
              }}
            </b-button>
          </template>

        </b-overlay>

      </b-card-body>
    </div>
  </div>
</template> 

<script>
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import CardHeader from '../../components/common/cardHeader.vue';
import MemberSelectModal from '../../components/common/memberSelectModal.vue'
import TrainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import { hasRole } from "esep/src/services/utils";
import { roles, routes } from "esep/src/services/routing.service";


export default {
  components: {
    TrainingToolbar,
    CardHeader,
    MemberSelectModal,
  },
  computed: {
    membersCount() {
      return this.selectedMembers.length;
    },
  },
  mounted() {
    this.getAllModules();
    this.getCurrentCensusPeriod();
    TrainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo, roles.training.leaders)) {
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      modules: null,
      selectedModule: null,
      availableMembers: null,
      selectedMembers: [],
      search: null,
      loading: false,
      loadingBatch: false,
      currentCensus: null,
      selectedMembersFields: [
        { key: 'member.id', label: "Αριθμός Μητρώου", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'member.surName', label: "Επώνυμο", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'member.firstName', label: "Όνομα", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'member.lastYearCensus', label: "Απογραφή" },
        { key: 'member.orgUnit.name', label: "Κλιμάκιο", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'action', label: "Ενέργεια" }
      ],
    }
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length > 0;
    },
    getAllModules() {
      TrainingService.getModulesByCriteria(true, null, false).then(
        (response) => {
          this.$log.debug(response.data)
          this.modules = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getCurrentCensusPeriod() {
      TrainingService.getCurrentCensusPeriod().then(
        (response) => {
          this.currentCensus = response.data.yearCensus;
        },
        (error) => {
          this.handleError(handleApiError(error))
        }
      );
    },
    getAvailableLeaders() {
      this.loading = true;
      TrainingService.getMembersByCriteria(null, ['REGISTERED', 'NEW_MEMBER'], this.search, null, ['LEADER', 'ROVER', 'SUPPORT', 'OLD_SCOUT']).then(
        (response) => {
          this.cancelSource = null;
          let leaders = response.data;
          leaders.forEach(leader => {
            leader.fullName = leader.surName + " " + leader.firstName;
          })
          this.availableMembers = leaders;
          console.log(this.availableMembers)
          this.loading = false;
          this.$bvModal.show('modal-member');
        },
        (error) => {
          this.cancelSource = null;
          this.failedRequest('error:api', error);
          this.loading = false;
        }
      )
    },
    assignMembers(members) {
      this.$bvModal.hide('modal-member');
      let newMembers = this.selectedMembers;
      members.forEach(member => { newMembers.push({ member: member }) });

      this.selectedMembers = newMembers;
    },
    deleteMember(member) {
      for (let j = 0; j < this.selectedMembers.length; j++) {
        if (this.selectedMembers[j].id === member.id) {
          this.selectedMembers.splice(j, 1);
          j = this.selectedMembers.length;
        }
      }
    },
    resetPage() {
      this.selectedModule = null;
      this.selectedMembers = [];
      this.search = null;
    },
    updateProfiles() {
      this.loadingBatch = true;
      let alteredMembers = this.selectedMembers.map(member => member.member)
      TrainingService.batchCreateProfiles(this.selectedModule, alteredMembers).then(
        (response) => {
          this.$log.debug(response.data)
          this.successMessage = this.$t('profileBatch.updatedSuccessfully');
          this.loadingBatch = false;
          this.popSuccessAlert = true;
          this.resetPage();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
          this.loadingBatch = false;
        }
      )
    }
  }
}
</script>